export enum EndPoints {
  JWTAPI = "/jwt",
  ONBOARDING = "/onboarding",
  //generals
  COMPANYNEWS = "/general/companynews",
  COMPANY = "/general/companies",
  DOCUMENTTEMPLATE = "/general/documenttemplate",
  ADDDOCUMENTTEMPLATE = "/general/documenttempate/add",

  //pages
  ANALYTICS = "/analytics",
  TICKETS = "/tickets",
  RECURRINGTICKETS = "/settings/tickets/recurringtickets",
  TICKETCALENDARS = "/ticketcalendar",
  KANBAN = "/kanban",
  ADDTICKET = "/ticket/add",
  SUBTICKET = "/subticket",
  ASSETS = "/assets",
  ADDASSET = "/asset/add",
  INCIDENTS = "/incident",
  ADDINCIDENT = "/incident/add",
  PURCHASEORDERS = "/purchaseorders",
  PURCHASEREQUESTS = "/purchaserequests",
  REQUESTFORPROPOSAL = "/requestforproposal",
  REQUESTFORQUOTATION = "/requestforquotation",
  ADDPURCHASEORDER = "/purchaseorder/add",
  PENDINGREQUESTS = "/pendingrequests",
  TICKETRAPORTS = "/raports/tickets",
  ASSETSRAPORTS = "/raports/assets",
  MANAGEUSERS = "/manageusers",

  //start page
  LOGIN = "/login",
  REGISTER = "/register",
  RESETPASSWORD = "/login/resetpassword",
  FORGOTPASSWORD = "/login/forgotpassword",
  ABOUTUS = "/aboutus",
  FAQ = "/faq",
  USERS = "/users",
  PROFILE = "/profile",
  SUPPORT = "/support",
  VERIFYEMAIL = "/verifyemail",
  CONFIRMEMAIL = "/confirm-email",

  //settings ticket
  CATEGORIES = "/settings/tickets/categories",
  CONTRACTORS = "/settings/tickets/contractors",
  ADDUSER = "/settings/tickets/adduser",
  CUSTOMERS = "/settings/tickets/customers",
  ADDCUSTOMERS = "/settings/tickets/addcustomer",
  INTERVENTIONTYPE = "/settings/tickets/interventiontype",
  LOCATIONS = "/settings/tickets/locations",
  STATUSES = "/settings/tickets/statuses",
  PRIORITIES = "/settings/tickets/priorities",
  DEPARTMENTS = "/settings/tickets/departments",
  //settings asset
  ASSETDEPARTMENTS = "/settings/assets/departments",
  ASSETLOCATIONS = "/settings/assets/locations",
  ASSETCATEGORIES = "/settings/assets/categories",
  ASSETTYPES = "/settings/assets/types",
  ASSETSTATUSES = "/settings/assets/statuses",
  ASSETACTIONTYPES = "/settings/assets/actiontypes",

  //settings procurement
  VENDORS = "/settings/purchaseorders/vendors",
  VENDORSTATUSES = "/settings/purchaseorders/vendorstatuses",
  PURCHASEORDERTYPES = "/settings/purchaseorders/purchaseordertypes",
  APPROVALPERSONS = "/settings/purchaseorders/approvalpersons",
  EVALUATIONCRITERIAS = "/settings/purchaseorders/evaluationcriterias",
}
